export class State {
  stateID: number;
  stateNameEn: string;
  stateNameAr: string;
  createdAt: Date;
  createdBy: number;
  modifiedAt: Date;
  modifiedBy: number;
}
